export const boolToStringNum = (bool: boolean) => {
  if (bool) {
    return '1';
  } else {
    return '0';
  }
};
